import React from 'react'
import { IconButton } from '../../../../shared/components/buttons/icon-button/IconButton'
import { IconEye } from '../../../../shared/components/icons/IconEye'
import { IconEyeOff } from '../../../../shared/components/icons/IconEyeOff'

interface HiddenActionCellProps {
  is_hidden: boolean | null
  onToggle: () => void
}

export const HiddenActionCell = ({ is_hidden, onToggle }: HiddenActionCellProps) => {
  return (
    <IconButton size='lg' onClick={onToggle}>
      {is_hidden ? <IconEye color='#A059FF' /> : <IconEyeOff color='#A059FF' />}
    </IconButton>
  )
}
